import { render, staticRenderFns } from "./BossLoginAdminSystem.vue?vue&type=template&id=2e69f274&scoped=true"
import script from "./BossLoginAdminSystem.vue?vue&type=script&lang=js"
export * from "./BossLoginAdminSystem.vue?vue&type=script&lang=js"
import style0 from "./BossLoginAdminSystem.vue?vue&type=style&index=0&id=2e69f274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e69f274",
  null
  
)

export default component.exports